import { httpservice, baseURL } from "./httpService"
import axios from 'axios'


/**
 * Initiate Digilocker Verification
 */
export function initiateDigilocker(userInstituteDetailsId) {
    return httpservice()
        .post(`api/v1/kyc/digilocker/initiate/`, {userInstituteDetailsId: userInstituteDetailsId})
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            return error.data
        })
}



/**
 * Download Digilocker Aadhar
 */
export function downloadDigilocker(userInstituteDetailsId, digilockerClientId) {
    return httpservice()
        .get(`api/v1/kyc/digilocker/${digilockerClientId}/download-aadhaar?detailId=${userInstituteDetailsId}`)
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            return error.data
        })
}